$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  let posType = $("#classic-location-products").data("pos-type");
  if (p === "events" && posType === "scroll") {
    $(document).on("submit", ".product-search-form", function (e) {
      e.preventDefault();
      let formData = new FormData($(this)[0]);
      formData.append("pos_type", posType);
      $.ajax({
        type: "POST",
        url: "/ajax/events/get_all_products",
        data: formData,
        enctype: "multipart/form-data",
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data) {
            if (data.search) {
              $(".product-group").hide();
            } else {
              $(".product-group").show();
            }
            $("#product-group-").html(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on("click", ".category-nav-link", function (e) {
      const locationId = parseInt($("#location-products").data("location-id"));
      const formData = new FormData();
      $("#search_string").val("");
      formData.append("search_string", "");
      formData.append("event_id", locationId);
      const postype = localStorage.getItem("postype") ?? null;
      formData.append("pos_type", postype);
      $.ajax({
        type: "POST",
        url: "/ajax/events/get_all_products",
        data: formData,
        enctype: "multipart/form-data",
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data) {
            if (data.search) {
              $(".product-group").hide();
            } else {
              $(".product-group").show();
            }
            $("#product-group-").html(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
  }

  if (p === "events" && posType === "classic") {
    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();
      // let page = parseInt($(this).attr("href").substring(6));
      // let page = parseInt($(this).attr("href").match(/page=(\d+)/)[1]);
      let href = $(this).attr("href");
      let urlParams = new URLSearchParams(href.substring(1));
      let page = parseInt(urlParams.get("page"));
      let search_string = $("#search_string").val();
      const activeCategoryTab = $(".tablinks.active");
      const categoryId = activeCategoryTab.length
        ? activeCategoryTab.data("category-id")
        : null;

      const formData = new FormData();
      formData.append("page", page);
      formData.append("search_string", search_string);
      formData.append("category_id", categoryId);
      formData.append("location_id", $("#location-id").val());

      $.ajax({
        type: "POST",
        url: "/api/v1/private/products/get-category-products",
        data: formData,
        enctype: "multipart/form-data",
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (
            data.products_html &&
            data.products_html !== undefined &&
            data.products_html !== null
          ) {
            $(".tabcontent #category-" + categoryId).html(data.products_html);
          }
          if (data.pagination) {
            $(".tabcontent #pagenation-container-" + categoryId).html(
              data.pagination
            );
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
            return;
          }

          if (data.responseJSON.error) {
            showToast({
              type: "error",
              title: "Error",
              message: data.responseJSON.error,
              position: "top-right",
              duration: 4000,
            });
          }
        });
    });
  }
});

function selectCategory(evt, categoryId) {
  $(".tabcontent").hide();
  $(".tablinks").removeClass("active");
  // console.log(categoryId);
  $("#category-tabcontent-" + categoryId).css("display", "block");
  $(evt.currentTarget).addClass("active");

  if (categoryId !== "all" && $("#search_string").val() !== "") {
    const container = $("#pagenation-container-" + categoryId);
    // Disable all <a> inside this container
    container.find("a").each(function () {
      $(this).css({
        "pointer-events": "none",
        color: "#999", // optional: gray it out
        "text-decoration": "none", // optional: remove underline
      });
    });

    // Optional: Change cursor globally
    container.css("cursor", "not-allowed");
  }
}
